import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isObjectArray } from '../../../utilities/utilityFunctions';
import { hideMenu, selectRouteTrackingSorterDetail, setSortItem, toggleAscending, toggleMenu } from './reducerSlices/routeTrackingSorterSlice';

function RouteTrackingSorter(props) {
    const dispatch = useDispatch();
    const routeTrackingSorterDetail = useSelector(selectRouteTrackingSorterDetail);

    const sortByContainerRef = useRef(null);

    useEffect(() => {
        if (routeTrackingSorterDetail.open && sortByContainerRef && sortByContainerRef.current) {
            sortByContainerRef.current.focus();
        }
    });

    let _sortByList;
    if (isObjectArray(routeTrackingSorterDetail.sortByItems)) {
        if (routeTrackingSorterDetail.sortByItems.length > 0) {
            _sortByList = routeTrackingSorterDetail.sortByItems.map((sortByItem, index) => (
                <li
                    className="sort-by-menu-item"
                    onClick={(e) => onSortItemClicked(e, sortByItem.value, sortByItem.text)}>
                    {sortByItem.text}
                </li>
            ));
        }
    }

    const onBlur = (e) => {
        dispatch(hideMenu());
    };

    const onSorted = (e) => {
        dispatch(toggleAscending(!routeTrackingSorterDetail.ascending));
        props.onSorted && props.onSorted(routeTrackingSorterDetail.sortBy, !routeTrackingSorterDetail.ascending);
    };

    const onSortItemClicked = (e, value, text) => {
        dispatch(setSortItem({
            sortByText: text,
            sortBy: value,
            open: false
        }));
        props.onSorted && props.onSorted(value, routeTrackingSorterDetail.ascending);
    };

    const toggle = () => {
        dispatch(toggleMenu(!routeTrackingSorterDetail.open));
    };

    return (
        <div className="sort-by-container">
            <div>
                <span className="sort-by" onClick={(e) => toggle()}>{routeTrackingSorterDetail.sortByText}</span>
                {routeTrackingSorterDetail.open ? <div className="sort-by-menu"
                    ref={sortByContainerRef}
                    tabIndex={-1}
                    onBlur={(e) => onBlur(e)}>
                    <ul className="sort-by-menu-items">
                        {_sortByList}
                    </ul>
                </div> : <></>}
            </div>
            <span className="sort-button" onClick={(e) => onSorted(e)}><i className={routeTrackingSorterDetail.ascending ? "fa fa-chevron-down" : "fa fa-chevron-up"}></i></span>
        </div>
    );
}

export default RouteTrackingSorter